import { render } from "./PaymentPlan.vue?vue&type=template&id=7bc02530&scoped=true"
import script from "./PaymentPlan.vue?vue&type=script&lang=js"
export * from "./PaymentPlan.vue?vue&type=script&lang=js"

import "./PaymentPlan.vue?vue&type=style&index=0&id=7bc02530&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc02530"]])

export default __exports__